<template>
    <div class="top_con">
         <el-button type="primary" @click="add" style="margin-top:20px;" v-if="GWAdd==true">添加</el-button>
         <el-button type="primary" @click="edit" style="margin-top:20px;"  v-if="GWEdit==true">编辑</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" highlight-current-row  @current-change="handleSelectionChange"  max-height="580px">
            <el-table-column  prop="id"  label="序号"></el-table-column>
            <el-table-column  prop="gangwei"  label="岗位名称"></el-table-column>
            <el-table-column prop="addtime"  label="添加时间"></el-table-column>
            <el-table-column prop="upUser"  label="添加人" ></el-table-column>
            <el-table-column  label="状态"  v-if="GWqj==true">
                 <template slot-scope="scope">
                    <el-link :underline="false" @click="qy(0,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==1">启用</el-link>
                    <el-link :underline="false" @click="qy(1,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==0">禁用</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>
<script>
import {getGwList,getGwList_Add,getGwList_Edit,getGwList_qj} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                numbers:'',
                prodName:'',
                wid:'',
                sPrice:'',
                price:'',
                fit:'',
            },
            dialogFormVisible:false,
            chuKu:false,
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
            pageNum:1,
            GWAdd:false,
            GWEdit:false,
            GWqj:false
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                userId:this.user.uid,
                numPerPage:this.value,
                pageNum:this.pageNum,
            }
            getGwList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
                this.GWAdd=res.qx.GWAdd
                this.GWEdit=res.qx.GWEdit
                this.GWqj=res.qx.GWqj
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        add(){
            this.$prompt('请输入岗位分类名称', '添加', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(({ value }) => {
                getGwList_Add({userId:this.user.uid,gangwei:value}).then(res=>{
                    let param ={
                        userId:this.user.uid,
                        numPerPage:this.value,
                        pageNum:this.pageNum,
                    } 
                    getGwList(param).then(res=>{
                        this.total=res.total;
                        this.tableData=res.list;
                        this.GWAdd=res.qx.GWAdd
                        this.GWEdit=res.qx.GWEdit
                        this.GWqj=res.qx.GWqj
                    });
                    this.$message({
                        type: 'success',
                        message: '添加成功 '
                    });
                });
                
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        edit(){
            if(this.multipleSelection==''){
                this.$message({
                    type: 'info',
                    message: '请先选择要编辑的内容'
                });   
            }else{
                this.$prompt('请输入要修改的岗位分类名称', '修改', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue:this.multipleSelection.gangwei
                }).then(({ value }) => {
                    getGwList_Edit({id:this.multipleSelection.id,userId:this.user.uid,gangwei:value}).then(res=>{
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getGwList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.GWAdd=res.qx.GWAdd
                            this.GWEdit=res.qx.GWEdit
                            this.GWqj=res.qx.GWqj
                        });
                        this.$message({
                            type: 'success',
                            message: '修改成功 '
                        });
                    })
                    
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            }
        },
        qy(idx,id){
            this.$confirm('确定此操作, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let param ={
                        userId:this.user.uid,
                        id:id,
                        qy_jy:idx
                    }
                    getGwList_qj(param).then(res=>{
                        if(idx==0){
                            this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                        }else{
                            this.$message({
                                type: 'success',
                                message: '启用成功!'
                            });
                        }
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getGwList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.GWAdd=res.qx.GWAdd
                            this.GWEdit=res.qx.GWEdit
                            this.GWqj=res.qx.GWqj
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            userId:this.user.uid,
            numPerPage:this.value,
            pageNum:this.pageNum,
        } 
        getGwList(param).then(res=>{
            this.total=res.total;
            this.tableData=res.list;
            this.GWAdd=res.qx.GWAdd
            this.GWEdit=res.qx.GWEdit
            this.GWqj=res.qx.GWqj
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/JobWork.vue